<template>
  <div id="main_div">
    <!-- Home Section start-->

    <!--Home Section start-->
    <section id="home" class="home vertical-scrolling">
      <div class="container">
        <div class="row">
          <div class="home-page-container col-md-8 col-sm-12">
            <div class="home-contain">
              <div class="text-white">
                <div class="contain">
                  <h1 class="text-white">
                    
                     <slot name="taption_header"></slot>
                  </h1>
                  <h4 class="slide-desc">
                     <slot name="landing_description"></slot>
                  </h4>
                  <!-- <router-link :to="login"> -->
                    <a :href="getLoginUrl">
                    <button class="btn btn-custom ">
                     <slot name="start_your_trial"></slot>
                    </button>
                  </a>
                  <!-- </router-link> -->
                  <!-- <slot name="intro_video"></slot> -->
                </div>
                <div
                  v-on:click="isHidden = !isHidden"
                  v-if="!isHidden"
                  :player-height="100"
                  class="white-popup"
                ></div>
              </div>
            </div>
          </div> 


          <div class="media-mentions-container col-md-10 col-sm-12">


          <About>
      <template slot="simple_workflow"><slot name="simple_workflow"></slot></template>
      <template slot="upload"><slot name="upload"></slot></template>
      <template slot="upload_description"><slot name="upload_description"></slot></template>
      <template slot="transcribe"><slot name="transcribe"></slot></template>
      <template slot="transcribe_description"><slot name="transcribe_description"></slot></template>
      <template slot="edit_translate"><slot name="edit_translate"></slot></template>
      <template slot="edit_translate_description"><slot name="edit_translate_description"></slot></template>
      <template slot="translate"><slot name="translate"></slot></template>
      <template slot="translate_description"><slot name="translate_description"></slot></template>
      <template slot="export"><slot name="export"></slot></template>
      <template slot="export_description"><slot name="export_description"></slot></template>
      <template slot="try_it_now"><slot name="try_it_now"></slot></template>
    </About>

<div class="fading-line"></div>

          <slot name="as_seen_on"></slot>
          
<VueSlickCarousel v-bind="settings">
                      <div class="as-seen-on-logo">
                            <img :src='"@/assets/images/partners/usatoday.webp"' alt="usatoday partner logo" width="200" height="75">
                      </div>

                      <div class="as-seen-on-logo">
                            <img :src='"@/assets/images/partners/meetstartups.webp"' alt="meetstartups partner logo" width="200" height="75">
                      </div>

                      <div class="as-seen-on-logo">
                            <img :src='"@/assets/images/partners/fox.webp"' alt="fox partner logo" width="200" height="75">
                      </div>

                      <div class="as-seen-on-logo">
                             <img :src='"@/assets/images/partners/digitimes.webp"' alt="digitimes partner logo" width="200" height="75">
                      </div>


                      <div class="as-seen-on-logo">
                            <img :src='"@/assets/images/partners/marketwatch.webp"' alt="marketwatch partner logo" width="200" height="75">
                      </div>

                      <div class="as-seen-on-logo">
                              <img :src='"@/assets/images/partners/technews.webp"' alt="technews partner logo" width="200" height="75">
                      </div>

                      <div class="as-seen-on-logo">
                            <img :src='"@/assets/images/partners/digitaljournal.webp"' alt="digitaljournal partner logo" width="200" height="75">
                      </div>

</VueSlickCarousel>
          </div>
        </div>
      </div>
    </section>
    
    <UseCase>
      <template slot="use_case_title"><slot name="use_case_title"></slot></template>
      <template slot="youtubers"><slot name="youtubers"></slot></template>
      
      <template slot="youtubers_question"><slot name="youtubers_question"></slot></template>
      <template slot="youtubers_desc"><slot name="youtubers_desc"></slot></template>
      <template slot="journalists"><slot name="journalists"></slot></template>
      <template slot="journalists_question"><slot name="journalists_question"></slot></template>
      <template slot="journalists_desc"><slot name="journalists_desc"></slot></template>
      <template slot="translators"><slot name="translators"></slot></template>
      <template slot="translators_question"><slot name="translators_question"></slot></template>
      <template slot="translators_desc"><slot name="translators_desc"></slot></template>

      <template slot="speaker"><slot name="speaker"></slot></template>
      <template slot="speaker_question"><slot name="speaker_question"></slot></template>
      <template slot="timealign"><slot name="timealign"></slot></template>
      <template slot="timealign_question"><slot name="timealign_question"></slot></template>
      <template slot="audiotomp4"><slot name="audiotomp4"></slot></template>
      <template slot="audiotomp4_question"><slot name="audiotomp4_question"></slot></template>
      <template slot="importsrt"><slot name="importsrt"></slot></template>
      <template slot="importsrt_question"><slot name="importsrt_question"></slot></template>
      <template slot="share"><slot name="share"></slot></template>
      <template slot="share_question"><slot name="share_question"></slot></template>

      <template slot="learnmore"><slot name="learnmore"></slot></template>
    </UseCase>

  <Unique class="landing-unique">
      <template slot="editing_platform"><slot name="editing_platform"></slot></template>
      <template slot="editing_platform_desc0"><slot name="editing_platform_desc0"></slot></template>
      <template slot="video_trimmed"><slot name="video_trimmed"></slot></template>

      <template slot="editing_platform_desc1"><slot name="editing_platform_desc1"></slot></template>
      <template slot="video_time_stampped"><slot name="video_time_stampped"></slot></template>

      <template slot="editing_platform_desc2"><slot name="editing_platform_desc2"></slot></template>
      <template slot="video_replace_all"><slot name="video_replace_all"></slot></template>
      <template slot="editing_platform_desc3"><slot name="editing_platform_desc3"></slot></template>
      <template slot="video_add_dictionary"><slot name="video_add_dictionary"></slot></template>
  </Unique> 


  </div>
</template>
<script>
import About from "@/components/landing/About.vue";
import Unique from "@/components/landing/Unique.vue";
import UseCase from "@/components/landing/UseCase.vue";
import VueSlickCarousel from 'vue-slick-carousel'
import textHelper from "@/utils/textManager";
import 'vue-slick-carousel/dist/vue-slick-carousel.css'
import Typed from 'typed.js';

export default {
  name: "Home_two",
  components: {
    About,
    UseCase,
    Unique,
    VueSlickCarousel
  },
  data() {
    return {
      isHidden: true,
      videoid: 54298665,
      login: { name: "login" },
      settings:{
  "arrows": false,
  "dots": false,
  "infinite": true,
  "slidesToShow": 4,
  "slidesToScroll": 1,
  "autoplay": true,
  "speed": 5000,
  "autoplaySpeed": 2000,
  "adaptiveHeight": true,
  "cssEase": "linear"
},
      src:
        "https://firebasestorage.googleapis.com/v0/b/taption-production.appspot.com/o/system%2Fen_crop_com.mp4?alt=media&token=a2462adf-a688-4dca-bcc9-d0c7afd48ea6"
    };
  },
  computed: {
    isEnglish() {
      const me = this;
      const currentLang = me.$lang.getLang();
      return !currentLang || currentLang === "en-US";
    },
    getLoginUrl(){
      return textHelper.getAppLoginUrl();
    }
  },
  methods:{
    onLogin(){
      window.location.href = textHelper.getAppLoginUrl();
    },
    animateTitle(){
      return new Typed('#text1', { 
      stringsElement: '#text1-strings',
      backDelay:1800,
      backSpeed: 50,
      loop:true,
      showCursor: true,
      contentType: 'null',
      autoInsertCss: true,
      typeSpeed: 50,
    });
    }
  },
  mounted() {
    const me = this;
    if (me.isEnglish) {
      me.src =
        "https://firebasestorage.googleapis.com/v0/b/taption-production.appspot.com/o/system%2Fen_crop_com.mp4?alt=media&token=a2462adf-a688-4dca-bcc9-d0c7afd48ea6";
    } else {
      me.src =
        "https://firebasestorage.googleapis.com/v0/b/taption-production-taiwan/o/system%2Fch_crop_com.mp4?alt=media&token=7bd7d213-cf0e-4d4b-8cc7-d3506594caa1";
    }
    me.animateTitle();
  }
};
</script>

<style>

.typed-cursor {
  color:#3CCEBD;
}

p {
  text-transform: none !important;
}


section {
  padding-bottom: 50px;
  padding-top: 0px;
  margin-top: 80px !important;
}
.taption .home {
  min-height: auto !important;
  height: auto !important;
  padding-bottom: 0px;
}

.taption .text-white {
  width: 100%;
}
.taption h1 {
  font-size: 53px;
  text-decoration: none;
  text-transform: none;
  font-weight: 400;
}

.home-page-container {
  margin: 0 auto;
}

.media-mentions-container {
  margin: 0 auto;
  padding-bottom:100px!important;
}

.media-mentions-container h1{
  padding-bottom:40px;
}
.taption .btn {
  margin: 0 auto;
  display: block;
  margin-top: 20px;
  margin-bottom: 30px;
  text-transform: initial;
  /* background: #3ccebd; */
  color: white;
  background-color: #3ccebd;
  transition: all .3s ease-in-out; 
  cursor: pointer;
  text-transform: uppercase;
  padding: 10px 25px;
  border: none;
  border-radius: 25px;
  font-size: 16px;
  font-weight: bold;
}

.taption .btn:hover {
  background-color: #00e0c6;
}
  .btn-custom:focus {
    outline: none; 
    }

.taption .slide-desc {
  color: #7f7f7f;
  font-size: 26px;
  line-height: 36px;
  font-weight: 300;
  letter-spacing: 1px;
}

.taption .home h1 {
  color: #1c2d27 !important;
  text-align: center;
}
.taption .home-contain h4 {
  color: #474343 !important;
  text-align: center;
}
.taption .home-contain p {
  color: #474343 !important;
  text-align: center;
  width: 50%;
  margin: 0 auto;
}

.taption .home-contain {
  margin-top: 10px;
  align-items: baseline;
  height: auto;
  width: 100%;
  background: #fafafa;
  background: white;
}

.intro-video {
  margin: 0px auto;
  display: block;
  width: 100%;
  height: 100%;
  border-radius: 50px;
}

.landing-tooltip {
  z-index: 3;
  opacity: 1 !important;
  background: white !important;
  box-shadow: 0 1px 4px rgba(1, 1, 1, 0.15);
  color: #7f7f7f;
  font-size: 16px;
  padding: 10px;
}

.landing-tooltip .cell {
  margin: 10px 20px;
  text-align: left;
  width: 100px;
  display: table-cell;
}

.landing-arrow-left{
  font-weight: bold;
  color: #00d1b2;
  margin-right: 10px;
}


.unique-video{
    margin: 0px auto;
    display: block;
    width: 100%;
    height: auto;
    border-radius: 10px;
}

.landing-unique .column{

  background: rgb(216 240 236 / 20%);
  border-radius: 10px;
}

.landing-unique .intro-video,
.landing-unique .unique-video{
    /* width: 80%; */
    margin: 40px 0px;
}


@media (max-width: 992px) {
  section.home {
    margin-top: 120px !important;
  }

  .taption .home-contain {
    display: contents;
  }
  .home h1 {
    margin-top: 20px !important;
    line-height: 57px;
  }

  .taption .home-contain p {
    text-align: center;
    word-break: keep-all;
    width: 100%;
  }
}


@media only screen and (max-device-width: 600px) {

.slick-slide{
  width:200px!important;
}

.taption h1 {
  font-size: 40px;
    letter-spacing: -2px;
}

.taption .slide-desc {
    font-size: 16px!important;
    line-height: 17px!important;
    margin-top: 10px!important;
}
}

</style>
